import { render } from "./MemoruTopContainer.vue?vue&type=template&id=ad3aa5b4&ts=true"
import script from "./MemoruTopContainer.vue?vue&type=script&lang=ts"
export * from "./MemoruTopContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__